import { render, staticRenderFns } from "./ClusterDetails.vue?vue&type=template&id=2995862a&scoped=true"
import script from "./ClusterDetails.vue?vue&type=script&lang=js"
export * from "./ClusterDetails.vue?vue&type=script&lang=js"
import style0 from "./ClusterDetails.vue?vue&type=style&index=0&id=2995862a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995862a",
  null
  
)

export default component.exports